import { CareerCategory, CareerPath } from '@backrs_ui/common-ui';

import {
  CareerPathWithScore,
  CareerUserResponseAnswer,
} from '@backrs_ui/grow-ui/src/models/models';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

import { Box, SxProps, Theme } from '@mui/material';
import { usePostHog } from 'posthog-js/react';

import { BestFitCareerPaths } from '../atoms/BestFitCareerPaths';
import { SuggestedCareerPaths } from '../atoms/SuggestedCareerPaths';
import { SECTION_GAP } from '../result.constant';

type CareerPathsProps = Readonly<{
  careerPathSuggestions: CareerPathWithScore[];
  careerPathCategories: CareerCategory[];
  userResponses: CareerUserResponseAnswer[];
}>;

export const CareerPaths = ({
  careerPathSuggestions,
  careerPathCategories,
  userResponses,
}: CareerPathsProps) => {
  const postHog = usePostHog();
  const dispatch = useAppDispatch();

  const sortedBySumCareerPath = [...careerPathSuggestions].sort((a, b) => b.sum - a.sum);

  function handleSettingCareerPathDialog(path: CareerPath) {
    if (!path) {
      return;
    }

    postHog.capture('opened_career_path', {
      id: path.id,
      name: path.name,
      page: 'Results',
    });

    dispatch(
      setCurrentDialogNugget({
        id: path.id,
        title: path.name,
        description: path.description,
        slug: path.id.toString(),
        star_rating: 0,
        value_rating: 0,
        variant: 'career-path',
        content_nugget_theme: 'Career Path',
        is_browsable: false,
        career_path_info: path,
      }),
    );
  }

  return (
    <>
      <Box sx={containerStyle}>
        <BestFitCareerPaths
          topFiveCareerPathsWithScore={sortedBySumCareerPath.slice(0, 5)}
          setCurrentDialogCareerPath={(path) => handleSettingCareerPathDialog(path.careerPath)}
        />
        <SuggestedCareerPaths
          careerPathSuggestions={sortedBySumCareerPath}
          careerPathCategories={careerPathCategories}
          userResponses={userResponses}
          setCurrentDialogCareerPath={(path) => handleSettingCareerPathDialog(path.careerPath)}
        />
      </Box>
    </>
  );
};

const containerStyle: SxProps<Theme> = {
  mt: { xs: SECTION_GAP / 2, sm: SECTION_GAP },
  gap: { xs: SECTION_GAP / 2, sm: SECTION_GAP },
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: {
    xs: 'column',
    sm: 'column',
    md: 'row',
  },
  flexGrow: 1,
  width: '100%',
};
